import type { CSSProperties, ReactNode } from 'react';
import { TYPE } from '../theme';

/** Small uppercase Geist Mono label, the site's .font-label-sm, in grey. */
export function MonoLabel({
  children,
  style,
  component: Component = 'span',
}: {
  children: ReactNode;
  style?: CSSProperties;
  component?: 'span' | 'div' | 'p';
}) {
  return <Component style={{ ...TYPE.monoLabel, display: 'block', margin: 0, ...style }}>{children}</Component>;
}
